.container {
  padding: 5px 2px 0;
}

.checkbox {
  display: flex;
  padding-bottom: 5px;
}

.label {
  white-space: nowrap;
}
